import React, { useEffect, useState } from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { getThreadsBySubCategory } from '../../services/boardService';
import { getCategoryById, getSubCategoryById } from '../../data/boardCategories';
import BoardThreadCard from '../../components/board/BoardThreadCard';

function ThreadList() {
  const { categoryId, subCategoryId } = useParams();
  const category = getCategoryById(categoryId);
  const subCategory = getSubCategoryById(categoryId, subCategoryId);

  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!category || !subCategory) return;
    getThreadsBySubCategory(subCategoryId, 20)
      .then(({ threads: t }) => setThreads(t))
      .catch((err) => console.error('[ThreadList]', err))
      .finally(() => setLoading(false));
  }, [categoryId, subCategoryId, category, subCategory]);

  if (!category || !subCategory) return <Navigate to="/board" replace />;

  const showYamatchCard = subCategoryId === 'find-partner';

  return (
    <div style={{ maxWidth: '896px', margin: '0 auto', padding: '12px 8px 80px' }}>
      {/* パンくず */}
      <div style={{ borderBottom: '1px solid var(--ch-border)', paddingBottom: '4px', marginBottom: '8px', fontSize: '12px' }}>
        <Link to="/board" style={{ color: 'var(--ch-link)' }}>トップ</Link>
        <span style={{ color: 'var(--ch-muted)' }}> &gt; </span>
        <Link to={`/board/${categoryId}`} style={{ color: 'var(--ch-link)' }}>{category.name}</Link>
        <span style={{ color: 'var(--ch-muted)' }}> &gt; </span>
        <span style={{ color: 'var(--ch-text)' }}>{subCategory.name}</span>
      </div>

      {/* タイトル行 */}
      <div style={{ marginBottom: '12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1 style={{ fontSize: '14px', fontWeight: 700, color: 'var(--ch-text)', margin: 0 }}>
          {subCategory.name} スレッド一覧
        </h1>
        <Link
          to={`/board/new-thread?categoryId=${categoryId}&subCategoryId=${subCategoryId}`}
          style={{
            backgroundColor: 'var(--ch-thread-btn)',
            color: '#ffffff',
            fontSize: '12px',
            padding: '3px 10px',
            textDecoration: 'none',
          }}
        >
          スレッドを作成
        </Link>
      </div>

      {/* ヤマッチ誘導カード（仲間募集サブカテゴリのみ） */}
      {showYamatchCard && (
        <a
          href="https://yamanoboro.com/"
          className="surface-link revisit-panel-strong"
          style={{ display: 'block', borderRadius: '12px', padding: '14px 16px', marginBottom: '12px', textDecoration: 'none' }}
        >
          <p style={{ fontSize: '14px', fontWeight: 600, color: 'var(--ui-accent-text)', margin: 0 }}>
            登山仲間を探すならヤマッチ
          </p>
          <p className="revisit-meta" style={{ fontSize: '12px', marginTop: '4px' }}>
            募集スレより具体的に相手を探したいときは、登山仲間マッチングサービス「ヤマッチ」も使えます。
          </p>
        </a>
      )}

      {/* スレッド一覧 */}
      {loading ? (
        <div className="revisit-panel" style={{ borderRadius: '12px', padding: '20px' }}>
          <p className="revisit-meta" style={{ fontSize: '13px' }}>読み込み中...</p>
        </div>
      ) : (
        <div style={{ border: '1px solid var(--ch-border)', backgroundColor: 'var(--ch-bg-post)', padding: '4px' }}>
          {threads.length === 0 ? (
            <p style={{ textAlign: 'center', padding: '32px 0', fontSize: '12px', color: 'var(--ch-muted)' }}>
              まだスレッドはありません
            </p>
          ) : (
            threads.map((t, i) => (
              <BoardThreadCard
                key={t.id}
                thread={t}
                categoryId={categoryId}
                subCategoryId={subCategoryId}
                index={i}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default ThreadList;
